import { useState } from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export default function ContactFormSection() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    console.log(formData);
  };

  return (
    <section className="pt-0 pb-10 sm:pb-14 md:pb-20 lg:pb-24 px-4 sm:px-6 md:px-8 lg:px-20 bg-white">
      {/* Header */}
      <div className="text-center mb-8 sm:mb-12">
        <Badge variant="outline" className="font-plus-jakarta text-xs sm:text-sm font-medium text-neutral-500 rounded-full px-3 sm:px-4 py-1.5 sm:py-2 mb-4 sm:mb-6">
          Ask Any Question
        </Badge>
        <h2 className="font-plus-jakarta text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-neutral-900 mb-4 sm:mb-6">
          STILL LOOKING FOR ANSWERS?
        </h2>
        <p className="font-plus-jakarta text-xs sm:text-sm md:text-base text-neutral-300 max-w-2xl mx-auto">
          If the answers you're looking for aren't in our FAQ, please send us an email by completing the form below.
        </p>
      </div>

      {/* Form */}
      <form onSubmit={handleSubmit} className="max-w-4xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-6">
          {/* Name */}
          <div>
            <label className="font-plus-jakarta text-sm font-medium text-neutral-900 mb-2 block">
              Name
            </label>
            <Input
              type="text"
              placeholder="Enter your Name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className="font-plus-jakarta bg-background-50 border-none shadow-none h-12 rounded-lg placeholder:text-neutral-300"
            />
          </div>

          {/* Email */}
          <div>
            <label className="font-plus-jakarta text-sm font-medium text-neutral-900 mb-2 block">
              Email <span className="text-error">*</span>
            </label>
            <Input
              type="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
              className="font-plus-jakarta shadow-none bg-background-50 border-none h-12 rounded-lg placeholder:text-neutral-300"
            />
          </div>
        </div>

        {/* Message */}
        <div className="mb-6 sm:mb-8">
          <label className="font-plus-jakarta text-sm font-medium text-neutral-900 mb-2 block">
            Message <span className="text-error">*</span>
          </label>
          <Textarea
            placeholder="Enter your Message Here"
            value={formData.message}
            onChange={(e) => setFormData({ ...formData, message: e.target.value })}
            required
            className="font-plus-jakarta shadow-none bg-background-50 border-none min-h-[150px] rounded-lg placeholder:text-neutral-300 resize-none"
          />
        </div>

        {/* Submit Button */}
        <Button
          type="submit"
          className="font-plus-jakarta font-bold bg-primary hover:bg-primary/90 text-white h-12 px-8 rounded-xl text-sm cursor-pointer"
        >
          Send
        </Button>
      </form>
    </section>
  );
}
